module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', _vm._l((_vm.msgs), function(msg) {
    return _c('span', {
      staticClass: "badge send-to-info"
    }, [_vm._v(_vm._s(msg))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4fbee8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/SendTo.vue
// module id = 281
// module chunks = 0